import React from 'react';

// Date/time line for event panels. Single-day events render the usual
// "DATE – TIME"; multi-day events break over two lines so long ranges
// don't overflow the thumbnail:
//   31 DECEMBER 2026, 16:52 –
//   2 JANUARY 2027, 16:52
function EventDateTime({ event }) {
  if (!event || !event.formattedDate) return null;

  if (event.multiDay) {
    return (
      <>
        {event.formattedDate}, {event.formattedTime}{' –'}
        <br />
        {event.formattedEndDate}, {event.formattedEndTime}
      </>
    );
  }

  return (
    <>
      {event.formattedDate}
      {' – '}
      {event.formattedTime}
    </>
  );
}

export default EventDateTime;
